<template>
  <div class="py-5 pr-3">
    <div class="flex justify-between">
      <div class="flex space-x-2">
        <div class="h-6 w-10 rounded-full cursor-pointer bg-neutral-200 items-center flex justify-center" @click="emit('back')">
          <svg fill="none" height="14" viewBox="0 0 21 14" width="21" xmlns="http://www.w3.org/2000/svg">
            <path d="M21 7H1M1 7L7.2 1M1 7L7.2 13" stroke="black" stroke-width="1.25"/>
          </svg>
        </div>
        <div>
          <strong>Checkout</strong>
          <div class="text-neutral-500 mb-15">
            Almost there!
          </div>
        </div>
      </div>
      <cart-close @close="() => emit('close')" />
    </div>

    <checkout-form/>
  </div>

</template>

<script lang="ts" setup>

const emit = defineEmits<{
  close: [void],
  back: [void]
}>()
</script>